import { createContext, useContext, useState } from "react";

const GriContext = createContext();

export const useGRI = () => useContext(GriContext);

export const GRIProvider = ({ children }) => {
  const [griId, setGriId] = useState(null);

  return (
    <GriContext.Provider value={{ griId, setGriId }}>
      {children}
    </GriContext.Provider>
  );
};
